import { makeAutoObservable } from 'mobx'

const not_login_route = [
    '/',
    '/:any/login',
    '/login',
    '/activity/fakao', // 法考活动
    '/activity/fashuo', // 法说活动
    '/activity/exam-signup', //主观题模考活动
    '/activity/20221212/index',
    '/w/downloadpc', // 下载页面
    '/activity/new-year-goods', // 年货节活动
    '/:type/activity/2023-new-user', //新人活动
    '/:type/activity/code/:id' //新人活动
]

export default class Router {
    static parent
    need_not_login_route = []

    constructor() {
        this.parent = parent
        makeAutoObservable(this)
        this.initNeedNotLoginRoute()
    }

    initNeedNotLoginRoute() {
        this.need_not_login_route = not_login_route.map((item) =>
            item.split('/')
        )
    }

    needLogin(route) {
        let 需要登录 = true
        route = route.split('/')

        // 循环不需要登录的路由列表
        for (let item of this.need_not_login_route) {
            // 如果输出的路由个数等于路由列表里单项的路由个数，说明可能是同一个路由
            if (route.length === item.length) {
                let 路由相等 = true
                // 循环对比每一项，如果每一项都想同，说明输入的路由不需要登录
                for (let i = 0; i < route.length; i++) {
                    // 如果当前路由段是：开头的说明是全匹配路由，认为这个路由匹配成功了
                    if (item[i].startsWith(':')) continue
                    // 比对完全想同
                    if (route[i] !== item[i]) {
                        路由相等 = false
                        break
                    }
                }
                if (路由相等) {
                    需要登录 = false
                    break
                }
            }
        }

        return 需要登录
    }
}
